export default {
  data () {
    return {
      hasSelectedList: [], // 已选中的数据
    };
  },
  watch: {
    // exchange 关闭批量操作时清空已选择的所有
    chooseable(v) {
        if (!v) {
            this.hasSelectedList = []
        }
    },
},
  methods: {
    // 选中或取消
    handleSelect(selecteds, row) {
      const ids = this.hasSelectedList.map(item => item.id);
      if (!ids.includes(row.id)) {
        // 在回显数据中不存在，加进来(选中)
        this.hasSelectedList.push(row);
      } else {
        // 在回显数据中已存在，删除(取消选中)
        this.hasSelectedList.forEach((item, index) => {
          if (item.id === row.id) {
            this.hasSelectedList.splice(index, 1);
          }
        });
      }
    },
    // 全选或取消全选
    handleSelectAll(selecteds, currrentPageList) {
      if (selecteds.length > 0) {
        const ids = this.hasSelectedList.map(item => item.id);
        selecteds.forEach(item => {
          if (!ids.includes(item.id)) {
            this.hasSelectedList.push(item);
          }
        });
      } else {
        currrentPageList.forEach(row => {
          this.hasSelectedList.forEach((item, index) => {
            if (item.id === row.id) {
              this.hasSelectedList.splice(index, 1);
            }
          });
        });
      }
    },
    // 获取分页数据后进行回显
    handleEchoData(tableRef, currrentPageList) {
      this.$nextTick(() => {
        const ids = this.hasSelectedList.map(item => item.id);
        currrentPageList.forEach(item => {
          // 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
          // toggleRowSelection(item, true)：设置当前行数据为选中状态
          if (ids.includes(item.id)) {
            this.$refs[tableRef].toggleRowSelection(item, true);
          }
        });
      })
    }
  }
}